import {createRouter, createWebHistory} from 'vue-router'
import MarshallIndex from '../pages/home.vue';
import OurSolutions from '../pages/our-solutions';
import SolutionDetails from '../pages/our-solutions/dynamic-details';
import Process from '../pages/our-process';
import OurClients from '../pages/clients';
import TermsAndConditions from '../pages/terms-and-conditions.vue';
import HowToPay from '../pages/how-to-pay';
import NotFound from '../pages/404';


const routes = [
    {
        path: '/',
        name: 'MarshallIndex',
        component: MarshallIndex,
    },
    {
      path: '/our-solutions',
      name: 'OurSolutions',
      component: OurSolutions,
    },
    {
        path: '/our-solutions/:id',
        name: 'Solution',
        component: SolutionDetails,
    },
    {
        path: '/our-process',
        name: 'OurProcess',
        component: Process,
    },
    {
      path: '/our-clients',
      name: 'OurClients',
      component: OurClients,
    },
    {
        path: '/terms-and-conditions',
        name: 'TermsAndConditions',
        component: TermsAndConditions,
    },
    {
      path: '/how-to-pay',
      name: 'HowToPay',
      component: HowToPay,
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: NotFound,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
